import React from 'react';

// Icons
import Icon1 from '../../../assets/images/informatics/icons/icon-1.png';
import Icon2 from '../../../assets/images/informatics/icons/icon-2.png';
import Icon3 from '../../../assets/images/informatics/icons/icon-3.png';
import Icon4 from '../../../assets/images/informatics/icons/icon-4.png';

import styles from './icons.module.scss';

function Icons() {
  return (
    <>
      <div className={styles.icons_div}>
        <span className={`${styles.icon_1}`}>
          <img src={Icon2?.src} />
        </span>
        <span className={`${styles.icon_2}`}>
          <img src={Icon1?.src} />
        </span>
      </div>
      <div className={styles.icons_div}>
        <span className={`${styles.icon_3}`}>
          <img src={Icon3?.src} />
        </span>
        <span className={`${styles.icon_4}`}>
          <img src={Icon4?.src} />
        </span>
      </div>
    </>
  );
}

function PageIcons() {
  return (
    <div className={styles.icons_wrapper}>
      <Icons />
    </div>

  );
}

export default PageIcons;
